import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectSegment } from 'next/entities/segments';
import { ConditionText } from './styled';

export const SegmentCondition = ({
  segmentName,
  negated,
  segment: segmentId,
}) => (
  <ConditionText>
    User must {negated ? 'not' : ''} belong to {segmentName || segmentId}
  </ConditionText>
);

SegmentCondition.propTypes = {
  segment: PropTypes.string,
  segmentName: PropTypes.string.isRequired,
  negated: PropTypes.bool,
};

const mapStateToProps = (state, { segment: segmentId }) => {
  return {
    segmentName: selectSegment(state, segmentId)?.name,
  };
};

export default connect(mapStateToProps)(SegmentCondition);
